import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9014c9a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receivable-history receivable-list-page" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "office-loading" }, "加载中...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "office-loading" }, "加载中...", -1))
const _hoisted_5 = { class: "search-actions" }
const _hoisted_6 = { class: "expand-arrow" }
const _hoisted_7 = { class: "list-panel" }
const _hoisted_8 = { class: "list-toolbar" }
const _hoisted_9 = {
  key: 0,
  class: "summary-action-text"
}
const _hoisted_10 = { class: "risk-level-text" }
const _hoisted_11 = {
  key: 0,
  class: "manual-modified-tag"
}
const _hoisted_12 = {
  key: 3,
  class: "risk-cell"
}
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "manual-modified-tag"
}
const _hoisted_15 = {
  key: 4,
  class: "risk-cell"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 0,
  class: "manual-modified-tag"
}
const _hoisted_18 = { class: "pagination-bar" }
const _hoisted_19 = { class: "pagination-total" }

import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import type { TableProps } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {
  queryReceivableHistoryPage,
  queryReceivableHistoryStatisticalData,
  queryHistoryArchiveVersionPage,
  RECEIVABLE_HISTORY_EXPORT_MODEL,
  RECEIVABLE_HISTORY_EXPORT_PATH,
  type ReceivableHistoryItem,
} from './index';
import { querySalesOfficePage } from '../receivableCustomer';
import ExportDialog from '../receivableManage/ExportDialog.vue';
import ViewHistoryRiskLogDialog from './ViewHistoryRiskLogDialog.vue';
import { useResizableColumns } from '../tableColumnResize';


export default /*#__PURE__*/_defineComponent({
  __name: 'receivableHistory',
  props: {
    onClose: null
  },
  setup(__props: any) {



const paginationLocale = zhCN.Pagination;

const financeAreaOptions = [
  { value: 'EAST', label: '东区' },
  { value: 'WEST', label: '西区' },
  { value: 'SOUTH', label: '南区' },
  { value: 'NORTH', label: '北区' },
];

const riskLevelOptions = [
  { value: '待人工确认', label: '待人工确认' },
  { value: '低', label: '低' },
  { value: '中', label: '中' },
  { value: '高', label: '高' },
];

/** 是/否：下拉用字符串，请求时转 boolean（避免 select 对 false 处理异常） */
const yesNoOptions = [
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

function toOptionalBoolean(value?: string) {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
}

const channelOptions = [
  { value: '10', label: '10渠道' },
  { value: '20', label: '20渠道' },
];

const searchForm = reactive({
  historyCode: undefined as string | undefined,
  financeArea: undefined as string | undefined,
  companyCode: undefined as string | undefined,
  financeOwner: '',
  customerCode: '',
  salesman: '',
  dissaleChannelCode: undefined as string | undefined,
  riskLevel: undefined as string | undefined,
  controlUserCode: '',
  hasControlUser: undefined as string | undefined,
  isProsecute: undefined as string | undefined,
  isOverdue: undefined as string | undefined,
});

const searchExpanded = ref(false);
/** 收起/展开均为每行 3 项；收起时整行由 CSS 与按钮区均分 1:1:1:1 */
const searchColSpan = 8;

function toggleSearchExpand() {
  searchExpanded.value = !searchExpanded.value;
  nextTick(() => {
    requestAnimationFrame(() => updateTableScrollY());
  });
}

const loading = ref(false);
const dataSource = ref<ReceivableHistoryItem[]>([]);
const selectedRowKeys = ref<string[]>([]);
const selectedMasterIds = ref<string[]>([]);
const tableAreaRef = ref<HTMLElement | null>(null);
const tableRenderKey = ref(0);

const TABLE_ROW_HEIGHT = 36;
const TABLE_HEADER_HEIGHT = 36;
const TABLE_SCROLLBAR_SIZE = 17;
const TABLE_BODY_FALLBACK = TABLE_ROW_HEIGHT * 8 + TABLE_SCROLLBAR_SIZE;
const tableScrollY = ref<number | undefined>(undefined);
const tableAreaMaxHeight = ref<number | undefined>(undefined);
const tableBodyYScroll = ref(false);

const { columns, scrollX, handleResizeColumn } = useResizableColumns([
  { title: '操作', key: 'action', width: 100, fixed: 'left' },
  { title: '归档版本', dataIndex: 'historyName', key: 'historyName', width: 140, ellipsis: true },
  { title: '是否专业客户', dataIndex: 'isProfessional', key: 'isProfessional', width: 110, ellipsis: true },
  { title: '财务大区', dataIndex: 'financeArea', key: 'financeArea', width: 90, ellipsis: true },
  { title: '公司', dataIndex: 'corpCode', key: 'corpCode', width: 100, ellipsis: true },
  { title: '分公司', dataIndex: 'companyName', key: 'companyName', width: 120, ellipsis: true },
  { title: '销售渠道', dataIndex: 'saleChannelName', key: 'saleChannelName', width: 120, ellipsis: true },
  { title: '渠道', dataIndex: 'channel', key: 'channel', width: 100, ellipsis: true },
  { title: '同一控制人', dataIndex: 'controller', key: 'controller', width: 110, ellipsis: true },
  { title: '客户编码', dataIndex: 'customerCode', key: 'customerCode', width: 120, ellipsis: true },
  { title: '客户名称', dataIndex: 'customerName', key: 'customerName', width: 180, ellipsis: true },
  { title: '付款条件', dataIndex: 'paymentTerm', key: 'paymentTerm', width: 140, ellipsis: true },
  { title: '应收账款余额', dataIndex: 'receivableBalance', key: 'receivableBalance', width: 130, ellipsis: true },
  { title: '信用期内', dataIndex: 'creditWithin', key: 'creditWithin', width: 100, ellipsis: true },
  { title: '逾期金额小计', dataIndex: 'overdueTotal', key: 'overdueTotal', width: 120, ellipsis: true },
  { title: '逾期1月', dataIndex: 'overdue1', key: 'overdue1', width: 90, ellipsis: true },
  { title: '逾期2月', dataIndex: 'overdue2', key: 'overdue2', width: 90, ellipsis: true },
  { title: '逾期3月', dataIndex: 'overdue3', key: 'overdue3', width: 90, ellipsis: true },
  { title: '逾期4月', dataIndex: 'overdue4', key: 'overdue4', width: 90, ellipsis: true },
  { title: '逾期5月', dataIndex: 'overdue5', key: 'overdue5', width: 90, ellipsis: true },
  { title: '逾期6月', dataIndex: 'overdue6', key: 'overdue6', width: 90, ellipsis: true },
  { title: '逾期7月', dataIndex: 'overdue7', key: 'overdue7', width: 90, ellipsis: true },
  { title: '逾期8月', dataIndex: 'overdue8', key: 'overdue8', width: 90, ellipsis: true },
  { title: '逾期9月', dataIndex: 'overdue9', key: 'overdue9', width: 90, ellipsis: true },
  { title: '逾期10月', dataIndex: 'overdue10', key: 'overdue10', width: 100, ellipsis: true },
  { title: '逾期11月', dataIndex: 'overdue11', key: 'overdue11', width: 100, ellipsis: true },
  { title: '逾期12月', dataIndex: 'overdue12', key: 'overdue12', width: 100, ellipsis: true },
  { title: '逾期超1年', dataIndex: 'overdueOverYear', key: 'overdueOverYear', width: 100, ellipsis: true },
  {
    title: '风险等级',
    dataIndex: 'riskLevel',
    key: 'riskLevel',
    width: 140,
    customCell: (record: ReceivableHistoryItem) => {
      if (record.isSummaryRow) return {};
      if (record.riskLevel === '高') return { class: 'risk-level-high' };
      if (record.riskLevel === '中') return { class: 'risk-level-mid' };
      return {};
    },
  },
  { title: '风险等级原因', dataIndex: 'riskReason', key: 'riskReason', width: 180, ellipsis: true },
  { title: '逾期原因及说明', dataIndex: 'overdueReason', key: 'overdueReason', width: 200, ellipsis: true },
  { title: '是否起诉客户', dataIndex: 'isProsecute', key: 'isProsecute', width: 110, ellipsis: true },
  { title: '分支财务', dataIndex: 'financeOwner', key: 'financeOwner', width: 110, ellipsis: true },
  { title: '分支财务工号', dataIndex: 'financeOwnerNo', key: 'financeOwnerNo', width: 130, ellipsis: true },
  { title: '业务员', dataIndex: 'salesman', key: 'salesman', width: 100, ellipsis: true },
  { title: '业务员工号', dataIndex: 'salesmanNo', key: 'salesmanNo', width: 120, ellipsis: true },
  { title: '分公司经理', dataIndex: 'companyManager', key: 'companyManager', width: 110, ellipsis: true },
  { title: '分公司经理工号', dataIndex: 'companyManagerNo', key: 'companyManagerNo', width: 130, ellipsis: true },
  { title: '数据同步时间', dataIndex: 'syncAt', key: 'syncAt', width: 160, ellipsis: true },
]);

const tableScroll = computed(() => {
  if (tableScrollY.value == null) return { x: scrollX.value };
  return { x: scrollX.value, y: tableScrollY.value };
});

const tableAreaStyle = computed(() => {
  const style: Record<string, string> = {};
  if (tableAreaMaxHeight.value != null) {
    style.maxHeight = `${tableAreaMaxHeight.value}px`;
  }
  if (tableScrollY.value != null) style['--receivable-table-body-h'] = `${tableScrollY.value}px`;
  style['--rc-row-height'] = `${TABLE_ROW_HEIGHT}px`;
  style['--rc-header-height'] = `${TABLE_HEADER_HEIGHT}px`;
  return style;
});

const pageSizeOptions = ['10', '15', '30', '50', '100', '200'];
const pagination = reactive({ current: 1, pageSize: 15, total: 0 });

function getRowKey(record: ReceivableHistoryItem, index?: number) {
  if (record?.isSummaryRow && record?.id) return String(record.id);
  const base = record?.masterId || record?.id || 'row';
  return `${base}-${pagination.current}-${index ?? 0}`;
}

function getCustomRow(record: ReceivableHistoryItem) {
  return {
    class: record.isSummaryRow ? 'summary-row' : undefined,
  };
}

function updateTableScrollY() {
  const area = tableAreaRef.value;
  if (!area) {
    tableScrollY.value = undefined;
    tableAreaMaxHeight.value = undefined;
    return;
  }
  const listPanel = area.parentElement as HTMLElement | null;
  const toolbar = listPanel?.querySelector('.list-toolbar') as HTMLElement | null;
  const paginationEl = listPanel?.querySelector('.pagination-bar') as HTMLElement | null;
  const headerEl = area.querySelector('.ant-table-header') as HTMLElement | null;
  const headerH = headerEl?.offsetHeight || TABLE_HEADER_HEIGHT;
  const panelH = listPanel?.clientHeight || area.clientHeight;
  const toolbarH = toolbar?.offsetHeight || 0;
  const paginationH = paginationEl?.offsetHeight || 0;
  const maxAreaH = Math.max(0, panelH - toolbarH - paginationH);
  const available = Math.floor(maxAreaH - headerH);
  const summaryExtra = dataSource.value.some((row) => row.isSummaryRow) ? 1 : 0;
  const needed =
    (Math.max(1, pagination.pageSize) + summaryExtra) * TABLE_ROW_HEIGHT +
    TABLE_SCROLLBAR_SIZE;

  if (available <= 0) {
    tableScrollY.value = TABLE_BODY_FALLBACK;
    tableAreaMaxHeight.value = undefined;
    tableBodyYScroll.value = true;
    return;
  }

  tableScrollY.value = available;
  tableAreaMaxHeight.value = maxAreaH || undefined;
  // 搜索收起且空间够 → 无竖滚；搜索展开空间不够 → 表内竖滚（行高/字号不变）
  tableBodyYScroll.value = available < needed;
}

const rowSelection = computed<TableProps['rowSelection']>(() => ({
  selectedRowKeys: selectedRowKeys.value,
  fixed: true,
  getCheckboxProps: (record: ReceivableHistoryItem) => ({
    disabled: !!record.isSummaryRow,
    style: record.isSummaryRow ? { display: 'none' } : undefined,
  }),
  onChange: (keys: (string | number)[], rows: ReceivableHistoryItem[]) => {
    selectedRowKeys.value = keys
      .map(String)
      .filter((key) => key !== '__receivable_history_summary__');
    selectedMasterIds.value = [
      ...new Set(
        (rows ?? [])
          .filter((row) => !row?.isSummaryRow)
          .map((row) => String(row?.masterId ?? '').trim())
          .filter(Boolean),
      ),
    ];
  },
}));

function blank(value?: string) {
  return (value ?? '').trim();
}

const exportQueryData = computed(() => {
  const data: Record<string, string | boolean> = {
    historyCode: blank(searchForm.historyCode),
    salesOfficeRegionCode: blank(searchForm.financeArea),
    saleOfficeCode: blank(searchForm.companyCode),
    sapCustomerCode: blank(searchForm.customerCode),
    financeCode: blank(searchForm.financeOwner),
    salesmanUserCode: blank(searchForm.salesman),
    dissaleChannelCode: blank(searchForm.dissaleChannelCode),
    feedbackStatus: '',
    riskLevel: blank(searchForm.riskLevel),
    controlUserCode: blank(searchForm.controlUserCode),
  };
  const hasControlUser = toOptionalBoolean(searchForm.hasControlUser);
  const isProsecute = toOptionalBoolean(searchForm.isProsecute);
  const isOverdue = toOptionalBoolean(searchForm.isOverdue);
  if (typeof hasControlUser === 'boolean') data.hasControlUser = hasControlUser;
  if (typeof isProsecute === 'boolean') data.isProsecute = isProsecute;
  if (typeof isOverdue === 'boolean') data.isOverdue = isOverdue;
  return data;
});

const ARCHIVE_PAGE_SIZE = 20;
const archiveOptions = ref<{ value: string; label: string }[]>([]);
const archiveFetching = ref(false);
const archiveKeyword = ref('');
const archivePage = ref(1);
const archiveTotalPages = ref(1);
const archiveHasMore = computed(() => archivePage.value < archiveTotalPages.value);
let archiveSearchTimer: ReturnType<typeof setTimeout> | null = null;
let archiveLoadingMore = false;

function mergeSelectOptions(
  prev: { value: string; label: string }[],
  next: { value: string; label: string }[],
) {
  const map = new Map(prev.map((item) => [item.value, item]));
  next.forEach((item) => map.set(item.value, item));
  return [...map.values()];
}

async function fetchArchiveOptions(reset: boolean) {
  if (archiveFetching.value && !reset) return;
  if (!reset && (archiveLoadingMore || !archiveHasMore.value)) return;
  const nextPage = reset ? 1 : archivePage.value + 1;
  archiveFetching.value = true;
  if (!reset) archiveLoadingMore = true;
  try {
    const pageData = await queryHistoryArchiveVersionPage({
      currentPage: nextPage,
      size: ARCHIVE_PAGE_SIZE,
      keyword: archiveKeyword.value,
    });
    const mapped = (pageData.content ?? [])
      .filter((item) => item.code)
      .map((item) => ({
        value: item.code,
        label: item.name ? `${item.name}（${item.code}）` : item.code,
      }));
    archiveOptions.value = reset ? mapped : mergeSelectOptions(archiveOptions.value, mapped);
    archivePage.value = nextPage;
    archiveTotalPages.value = Math.max(1, pageData.totalPages || 1);
  } catch (error) {
    if (reset) archiveOptions.value = [];
    message.error(error instanceof Error ? error.message : '查询归档版本失败');
  } finally {
    archiveFetching.value = false;
    archiveLoadingMore = false;
  }
}

function onArchiveSearch(keyword: string) {
  archiveKeyword.value = keyword;
  if (archiveSearchTimer) clearTimeout(archiveSearchTimer);
  archiveSearchTimer = setTimeout(() => fetchArchiveOptions(true), 300);
}

function onArchivePopupScroll(e: Event) {
  const target = e.target as HTMLElement;
  if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 24) {
    fetchArchiveOptions(false);
  }
}

function onArchiveDropdownVisible(open: boolean) {
  if (open && archiveOptions.value.length === 0) {
    archiveKeyword.value = '';
    fetchArchiveOptions(true);
  }
}

const OFFICE_PAGE_SIZE = 15;
const officeOptions = ref<{ value: string; label: string }[]>([]);
const officeFetching = ref(false);
const officeKeyword = ref('');
const officePage = ref(1);
const officeTotalPages = ref(1);
const officeHasMore = computed(() => officePage.value < officeTotalPages.value);
let officeSearchTimer: ReturnType<typeof setTimeout> | null = null;
let officeLoadingMore = false;

async function fetchOfficeOptions(reset: boolean) {
  if (officeFetching.value && !reset) return;
  if (!reset && (officeLoadingMore || !officeHasMore.value)) return;
  const nextPage = reset ? 1 : officePage.value + 1;
  officeFetching.value = true;
  if (!reset) officeLoadingMore = true;
  try {
    const pageData = await querySalesOfficePage({
      currentPage: nextPage,
      size: OFFICE_PAGE_SIZE,
      keyword: officeKeyword.value,
    });
    const mapped = (pageData.content ?? []).map((item) => ({
      value: item.code,
      label: item.name,
    }));
    officeOptions.value = reset ? mapped : mergeSelectOptions(officeOptions.value, mapped);
    officePage.value = nextPage;
    officeTotalPages.value = Math.max(1, pageData.totalPages || 1);
  } catch (error) {
    if (reset) officeOptions.value = [];
    message.error(error instanceof Error ? error.message : '查询分公司失败');
  } finally {
    officeFetching.value = false;
    officeLoadingMore = false;
  }
}

function onOfficeSearch(keyword: string) {
  officeKeyword.value = keyword;
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
  officeSearchTimer = setTimeout(() => fetchOfficeOptions(true), 300);
}

function onOfficePopupScroll(e: Event) {
  const target = e.target as HTMLElement;
  if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 24) {
    fetchOfficeOptions(false);
  }
}

function onOfficeDropdownVisible(open: boolean) {
  if (open && officeOptions.value.length === 0) {
    officeKeyword.value = '';
    fetchOfficeOptions(true);
  }
}

async function fetchList() {
  loading.value = true;
  dataSource.value = [];
  selectedRowKeys.value = [];
  selectedMasterIds.value = [];
  const filterParams = {
    historyCode: searchForm.historyCode,
    salesOfficeRegionCode: searchForm.financeArea,
    saleOfficeCode: searchForm.companyCode,
    sapCustomerCode: searchForm.customerCode,
    financeCode: searchForm.financeOwner,
    salesmanUserCode: searchForm.salesman,
    dissaleChannelCode: searchForm.dissaleChannelCode,
    riskLevel: searchForm.riskLevel,
    controlUserCode: searchForm.controlUserCode,
    hasControlUser: toOptionalBoolean(searchForm.hasControlUser),
    isProsecute: toOptionalBoolean(searchForm.isProsecute),
    isOverdue: toOptionalBoolean(searchForm.isOverdue),
  };
  try {
    const pageData = await queryReceivableHistoryPage({
      currentPage: pagination.current,
      size: pagination.pageSize,
      ...filterParams,
    });

    let rows = pageData.content;
    if (rows.length > 0) {
      try {
        const summaryRow = await queryReceivableHistoryStatisticalData(filterParams);
        if (summaryRow) {
          rows = [summaryRow, ...rows];
        }
      } catch (statError) {
        message.warning(
          statError instanceof Error ? statError.message : '获取合计数据失败',
        );
      }
    }

    dataSource.value = rows;
    pagination.total = pageData.totalElements;
    tableRenderKey.value += 1;
    nextTick(() => {
      requestAnimationFrame(() => updateTableScrollY());
    });
  } catch (error) {
    dataSource.value = [];
    pagination.total = 0;
    message.error(error instanceof Error ? error.message : '查询失败');
  } finally {
    loading.value = false;
  }
}

function handleSearch() {
  pagination.current = 1;
  fetchList();
}

function handleReset() {
  searchForm.historyCode = undefined;
  searchForm.financeArea = undefined;
  searchForm.companyCode = undefined;
  searchForm.financeOwner = '';
  searchForm.customerCode = '';
  searchForm.salesman = '';
  searchForm.dissaleChannelCode = undefined;
  searchForm.riskLevel = undefined;
  searchForm.controlUserCode = '';
  searchForm.hasControlUser = undefined;
  searchForm.isProsecute = undefined;
  searchForm.isOverdue = undefined;
  selectedRowKeys.value = [];
  selectedMasterIds.value = [];
  pagination.current = 1;
  fetchList();
}

function onPaginationChange(page: number, pageSize: number) {
  const sizeChanged = pageSize !== pagination.pageSize;
  pagination.current = sizeChanged ? 1 : page;
  pagination.pageSize = pageSize;
  fetchList();
}

const exportVisible = ref(false);
function handleExport() {
  exportVisible.value = true;
}

const logVisible = ref(false);
const logRecord = ref<ReceivableHistoryItem | null>(null);

function handleViewLog(record: ReceivableHistoryItem) {
  logRecord.value = record;
  logVisible.value = true;
}

let tableAreaRo: ResizeObserver | null = null;

onMounted(() => {
  window.addEventListener('resize', updateTableScrollY);
  nextTick(() => {
    updateTableScrollY();
    if (tableAreaRef.value && typeof ResizeObserver !== 'undefined') {
      tableAreaRo = new ResizeObserver(() => updateTableScrollY());
      tableAreaRo.observe(tableAreaRef.value);
    }
    requestAnimationFrame(() => updateTableScrollY());
  });
  fetchList();
});

onUnmounted(() => {
  window.removeEventListener('resize', updateTableScrollY);
  tableAreaRo?.disconnect();
  tableAreaRo = null;
  if (archiveSearchTimer) clearTimeout(archiveSearchTimer);
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["search-bar", { collapsed: !searchExpanded.value }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["search-bar-body", { expanded: searchExpanded.value }])
        }, [
          _createVNode(_component_a_form, {
            layout: "horizontal",
            colon: false,
            model: searchForm,
            class: "search-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [12, 12] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "归档版本" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.historyCode,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.historyCode) = $event)),
                            "show-search": "",
                            "allow-clear": "",
                            placeholder: "输入编码或名称搜索",
                            "filter-option": false,
                            options: archiveOptions.value,
                            "not-found-content": archiveFetching.value ? undefined : null,
                            onSearch: onArchiveSearch,
                            onPopupScroll: onArchivePopupScroll,
                            onDropdownVisibleChange: onArchiveDropdownVisible
                          }, _createSlots({ _: 2 }, [
                            (archiveFetching.value)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "options", "not-found-content"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "财务大区" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.financeArea,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.financeArea) = $event)),
                            "allow-clear": "",
                            placeholder: "全部",
                            options: financeAreaOptions
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "分公司" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.companyCode,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.companyCode) = $event)),
                            "show-search": "",
                            "allow-clear": "",
                            placeholder: "输入编码或名称搜索",
                            "filter-option": false,
                            options: officeOptions.value,
                            "not-found-content": officeFetching.value ? undefined : null,
                            onSearch: onOfficeSearch,
                            onPopupScroll: onOfficePopupScroll,
                            onDropdownVisibleChange: onOfficeDropdownVisible
                          }, _createSlots({ _: 2 }, [
                            (officeFetching.value)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "options", "not-found-content"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (searchExpanded.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "客户" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.customerCode,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.customerCode) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入客户编码或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "分支财务" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.financeOwner,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.financeOwner) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入工号或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "业务员" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.salesman,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchForm.salesman) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入工号或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "渠道" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.dissaleChannelCode,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchForm.dissaleChannelCode) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: channelOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "风险等级" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.riskLevel,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchForm.riskLevel) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: riskLevelOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "同一控制人" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.controlUserCode,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchForm.controlUserCode) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入编码或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否有同一控制人" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.hasControlUser,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((searchForm.hasControlUser) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否起诉客户" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.isProsecute,
                                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchForm.isProsecute) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否逾期" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.isOverdue,
                                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((searchForm.isOverdue) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { onClick: handleReset }, {
              default: _withCtx(() => [
                _createTextVNode("重置")
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              class: "expand-toggle",
              onClick: toggleSearchExpand
            }, [
              _createTextVNode(_toDisplayString(searchExpanded.value ? '收起' : '展开') + " ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(searchExpanded.value ? '▲' : '▼'), 1)
            ])
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handleExport
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          ref_key: "tableAreaRef",
          ref: tableAreaRef,
          class: "table-area",
          style: _normalizeStyle(_unref(tableAreaStyle))
        }, [
          (_openBlock(), _createBlock(_component_a_table, {
            key: tableRenderKey.value,
            class: _normalizeClass(["receivable-table", { 'is-y-scroll': tableBodyYScroll.value }]),
            columns: _unref(columns),
            "data-source": dataSource.value,
            loading: loading.value,
            pagination: false,
            scroll: _unref(tableScroll),
            "row-selection": _unref(rowSelection),
            bordered: true,
            "row-key": getRowKey,
            "custom-row": getCustomRow,
            size: "small",
            onResizeColumn: _unref(handleResizeColumn)
          }, {
            bodyCell: _withCtx(({ column, record, text }) => [
              (record.isSummaryRow)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (column.key === 'action')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "合计"))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(text ?? ''), 1)
                        ], 64))
                  ], 64))
                : (column.key === 'action')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "link",
                      size: "small",
                      onClick: ($event: any) => (handleViewLog(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 查看日志 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (column.key === 'riskLevel')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["risk-cell", {
                    'risk-level-fill-high': record.riskLevel === '高',
                    'risk-level-fill-mid': record.riskLevel === '中',
                  }])
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(record.riskLevel || '-'), 1),
                        (record.riskManualModified)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "人工改"))
                          : _createCommentVNode("", true)
                      ], 2))
                    : (column.key === 'riskReason')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createElementVNode("span", {
                            class: "risk-cell-text",
                            title: record.riskReason || ''
                          }, _toDisplayString(record.riskReason || '-'), 9, _hoisted_13),
                          (record.riskManualModified)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "人工改"))
                            : _createCommentVNode("", true)
                        ]))
                      : (column.key === 'overdueReason')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                            _createElementVNode("span", {
                              class: "risk-cell-text",
                              title: record.overdueReason || ''
                            }, _toDisplayString(record.overdueReason || '-'), 9, _hoisted_16),
                            (record.riskManualModified)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "人工改"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "columns", "data-source", "loading", "scroll", "row-selection", "onResizeColumn"]))
        ], 4),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(pagination.total) + " 条", 1),
          _createVNode(_component_a_pagination, {
            current: pagination.current,
            "onUpdate:current": _cache[12] || (_cache[12] = ($event: any) => ((pagination.current) = $event)),
            pageSize: pagination.pageSize,
            "onUpdate:pageSize": _cache[13] || (_cache[13] = ($event: any) => ((pagination.pageSize) = $event)),
            total: pagination.total,
            "show-size-changer": true,
            "show-quick-jumper": true,
            "page-size-options": pageSizeOptions,
            locale: _unref(paginationLocale),
            onChange: onPaginationChange
          }, null, 8, ["current", "pageSize", "total", "locale"])
        ])
      ])
    ]),
    _createVNode(ExportDialog, {
      visible: exportVisible.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((exportVisible).value = $event)),
      "master-id-list": selectedMasterIds.value,
      "query-data": _unref(exportQueryData),
      model: _unref(RECEIVABLE_HISTORY_EXPORT_MODEL),
      path: _unref(RECEIVABLE_HISTORY_EXPORT_PATH)
    }, null, 8, ["visible", "master-id-list", "query-data", "model", "path"]),
    _createVNode(ViewHistoryRiskLogDialog, {
      visible: logVisible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((logVisible).value = $event)),
      record: logRecord.value
    }, null, 8, ["visible", "record"])
  ]))
}
}

})